import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Users, FileText, CheckCircle, Clock, MapPin, ShieldAlert, TrendingUp, AlertTriangle } from 'lucide-react';
import { KPICard } from '../components/KPICard';
import { StatusBadge } from '../components/StatusBadge';
import { UrgencyBadge } from '../components/UrgencyBadge';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { BINDA_LIST } from '../data/binda';
import { useStore } from '../data/store';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/Select';
export default function KepalaBindaDashboard() {
  const navigate = useNavigate();
  const reportsList = useStore(s => s.reports);
  const alertsList = useStore(s => s.alerts);
  // Wilayah BINDA aktif (dapat diganti via pemilih wilayah).
  const [regionKode, setRegionKode] = useState(BINDA_LIST.find(b => b.provinsi === 'Jawa Barat')!.kode);
  const regionData = BINDA_LIST.find(b => b.kode === regionKode) || BINDA_LIST.find(b => b.provinsi === 'Jawa Barat')!;
  const regionalReports = reportsList.filter(r => r.region === regionData.provinsi && (r.stage === 'Analisis' || r.urgency === 'Kritis' || r.urgency === 'Tinggi'));
  const regionalAlerts = alertsList.filter(a => a.location === regionData.provinsi);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1320">
      <div className="flex justify-between items-end border-b border-border/50 pb-4" data-id="element-1321">
        <div data-id="element-1322">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground uppercase" data-id="element-1323">
            RINGKASAN EKSEKUTIF: {regionData.provinsi}
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-1324">
            {regionData.binda} // Tinjauan Strategis // Tinjauan Strategis // //
            Tinjauan Strategis // Tinjauan Strategis // Tinjauan Strategis //
            Tinjauan Strategis
          </p>
        </div>
        <div className="flex gap-3 items-center" data-id="element-1325">
          <Select value={regionData.kode} onValueChange={setRegionKode} data-id="element-1326">
            <SelectTrigger size="sm" className="w-[220px] font-mono text-xs" data-id="element-1327">
              <SelectValue placeholder="Pilih Wilayah / BINDA" data-id="element-1328" />
            </SelectTrigger>
            <SelectContent data-id="element-1329">
              {[...BINDA_LIST].sort((a, b) => a.provinsi.localeCompare(b.provinsi)).map(b => <SelectItem key={b.kode} value={b.kode} data-id="element-1330">
                    {b.provinsi}
                  </SelectItem>)}
            </SelectContent>
          </Select>
          <StatusBadge status={regionData.status} className="text-xs px-3 py-1.5" showDot data-id="element-1331" />
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-id="element-1332">
        <KPICard title="Total Operatif" value={regionData.personelAktif} icon={Users} colorVar="var(--primary)" trend={{
        value: 'SIAP DITUGASKAN',
        label: '',
        isPositive: true
      }} data-id="element-1333" />
        <KPICard title="Laporan Hari Ini" value={regionData.laporanHariIni} icon={FileText} colorVar="var(--status-info)" trend={{
        value: `${regionData.laporanPrioritas}`,
        label: 'PRIORITAS',
        isPositive: false
      }} data-id="element-1334" />
        <KPICard title="Tingkat Validasi" value={`${regionData.kpiWilayah}%`} icon={CheckCircle} colorVar="var(--status-active)" progress={{
        value: regionData.kpiWilayah,
        label: 'Target: 85%',
        target: '85%'
      }} data-id="element-1335" />
        <KPICard title="Rata-rata Respon" value="15m" icon={Clock} colorVar="var(--muted-foreground)" data-id="element-1336" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1337">
        {/* Priority Reports */}
        <Card className="glass-panel border-border/50 flex flex-col overflow-hidden" data-id="element-1338">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50 flex flex-row items-center justify-between shrink-0" data-id="element-1339">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-1340">
              <ShieldAlert className="w-4 h-4 text-destructive" data-id="element-1341" /> Laporan
              Prioritas Wilayah
            </CardTitle>
            <Button variant="ghost" size="sm" className="text-[10px] font-mono" onClick={() => navigate('/reports')} data-id="element-1342">
              Lihat Semua
            </Button>
          </CardHeader>
          <CardContent className="p-0 flex-1 overflow-auto" data-id="element-1343">
            <div className="divide-y divide-border/50" data-id="element-1344">
              {regionalReports.length > 0 ? regionalReports.map(report => <div key={report.id} className="p-4 hover:bg-secondary/30 transition-colors cursor-pointer" onClick={() => navigate(`/reports/${report.id}`)} data-id="element-1345">
                    <div className="flex justify-between items-start mb-2" data-id="element-1346">
                      <span className="font-mono text-xs text-primary" data-id="element-1347">
                        {report.id}
                      </span>
                      <UrgencyBadge urgency={report.urgency} data-id="element-1348" />
                    </div>
                    <div className="font-heading font-semibold text-sm mb-2" data-id="element-1349">
                      {report.title}
                    </div>
                    <div className="flex justify-between items-center text-[10px] font-mono text-muted-foreground" data-id="element-1350">
                      <StatusBadge status={report.status} data-id="element-1351" />
                      <span data-id="element-1352">{report.time.split(' ')[1]}</span>
                    </div>
                  </div>) : <div className="p-8 text-center text-muted-foreground font-mono text-xs" data-id="element-1353">
                  Tidak ada laporan prioritas di wilayah ini.
                </div>}
            </div>
          </CardContent>
        </Card>

        {/* Active Alerts */}
        <Card className="glass-panel border-border/50 flex flex-col overflow-hidden" data-id="element-1354">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50 flex flex-row items-center justify-between shrink-0" data-id="element-1355">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-1356">
              <AlertTriangle className="w-4 h-4 text-[var(--status-standby)]" data-id="element-1357" />{' '}
              Peringatan Aktif
            </CardTitle>
            <Button variant="ghost" size="sm" className="text-[10px] font-mono" onClick={() => navigate('/alerts')} data-id="element-1358">
              Lihat Semua
            </Button>
          </CardHeader>
          <CardContent className="p-0 flex-1 overflow-auto" data-id="element-1359">
            <div className="divide-y divide-border/50" data-id="element-1360">
              {regionalAlerts.length > 0 ? regionalAlerts.map(alert => <div key={alert.id} className="p-4 hover:bg-secondary/30 transition-colors cursor-pointer" onClick={() => navigate(`/alerts/${alert.id}`)} data-id="element-1361">
                    <div className="flex justify-between items-start mb-2" data-id="element-1362">
                      <UrgencyBadge urgency={alert.type} data-id="element-1363" />
                      <span className="text-[10px] font-mono text-muted-foreground" data-id="element-1364">
                        {alert.time}
                      </span>
                    </div>
                    <div className="font-mono text-sm mb-2 text-foreground/90" data-id="element-1365">
                      {alert.desc}
                    </div>
                    <div className="text-[10px] font-mono text-muted-foreground uppercase" data-id="element-1366">
                      Sumber:{' '}
                      <span className="text-primary" data-id="element-1367">{alert.source}</span>
                    </div>
                  </div>) : <div className="p-8 text-center text-muted-foreground font-mono text-xs" data-id="element-1368">
                  Tidak ada peringatan aktif di wilayah ini.
                </div>}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}